"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = convert_multiband;
function convert_multiband(old_no_data_value, new_no_data_value, scalefn1, scalefn2, scalefn3, pixel) {
  const [r, g, b] = pixel;
  return [
  // @ts-ignore
  r === old_no_data_value ? new_no_data_value : scalefn1(r),
  // @ts-ignore
  g === old_no_data_value ? new_no_data_value : scalefn2(g),
  // @ts-ignore
  b === old_no_data_value ? new_no_data_value : scalefn3(b),
  // @ts-ignore
  r === old_no_data_value || g === old_no_data_value || b === old_no_data_value ? 0 : 255];
}